exports = module.exports = require("../../../target/scala-2.13/scalajs-bundler/main/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App {\n    text-align: center;\n}\n\n.App-header {\n    background-color: #222;\n    height: 150px;\n    padding: 20px;\n    color: white;\n}\n\n.App-title {\n    font-size: 1.5em;\n}\n\n.App-intro {\n    font-size: large;\n}\n\n.recharts-wrapper {\n    display: inline-block;\n}\n", ""]);

